// import { View } from "@react-pdf/renderer";
// import { useMemo } from "react";

// const PdfGrid = ({ children, gap = 0, style, columns = 1 }) => {
//   const styles = useMemo(() => {
//     return {
//       display: "grid",
//       marginBottom: 5,
//       gridTemplateColumns: `repeat(${columns}, 1fr)`,
//       gap: gap,
//       ...style,
//     };
//   }, [style, columns, gap]);

//   return <View style={styles}>{children}</View>;
// };

// export default PdfGrid;
import React from "react";
import { View } from "@react-pdf/renderer";

const PdfGrid = ({ children, gap = 0, style, columns = 1 }) => {
  // Filter out null/undefined children (from conditional rendering)
  const validChildren = React.Children.toArray(children).filter(Boolean);

  // If no valid children, return null
  if (validChildren.length === 0) return null;

  // Calculate column width percentage
  const columnWidth = `${100 / columns}%`;

  // Group children into rows
  const rows = [];
  for (let i = 0; i < validChildren.length; i += columns) {
    rows.push(validChildren.slice(i, i + columns));
  }

  return (
    <View style={style}>
      {rows.map((row, rowIndex) => (
        <View
          key={rowIndex}
          style={{
            flexDirection: "row",
            marginBottom: rowIndex < rows.length - 1 ? gap : 0,
          }}
        >
          {row.map((child, colIndex) => (
            <View
              key={colIndex}
              style={{
                width: columnWidth,
                paddingRight: colIndex < row.length - 1 ? gap : 0,
                // Ensure content doesn't overflow
                overflow: "hidden",
              }}
            >
              {child}
            </View>
          ))}
        </View>
      ))}
    </View>
  );
};

export default PdfGrid;
